/**
 * SEO indexability guardrails
 * Centralizes route classification so commercial programmatic pages
 * are not accidentally noindexed by broad thin-page heuristics.
 */

const CORE_ROUTE_PATTERN = /^(about|faq|pricing|services|contact|careers|freelancers|industries|solutions|case-studies|insights|resources|why-morocco|testimonials|quote|get-started|start|order|free-week|blog|legal|compare|marketplace|jobs|how-it-works|bpo-outsourcing|call-center|call-center-for-|it-development|web-development|digital-marketing|seo-audit|why-us|leadership|fact-sheet|recognitions|newsroom|regions|bpo-hub|ai-contact-center|trust-center|glossary|esg|guides|security|compliance|onboarding|partners|clients|outsourcing-|html-sitemap|software-development-)($|\/)/;

const PROGRAMMATIC_COMMERCIAL_ROUTE_PATTERN = /^(bpo-services|it-development|web-development|digital-marketing|call-center)-[a-z0-9-]+$/;
const SOFTWARE_REGION_ROUTE_PATTERN = /^software-development-(?!agency-)[a-z0-9-]+$/;
const REGIONAL_LANDING_ROUTE_PATTERN = /^(call-center-(for-)?|outsourcing-)/;
const STRATEGIC_BPO_CLUSTER_PATTERN = /^bpo-(europe|north-america|latin-america|africa|asia|middle-east|oceania)$/;
const THIN_PROGRAMMATIC_PATTERN = /-bpo-|^software-development-agency-|^bpo-[a-z]/;
const LANGUAGE_SEGMENT_PATTERN = /^[a-z]{2}$/i;
const PRIVATE_UTILITY_ROUTE_PATTERN = /^(auth|admin|agent|portal|dashboard|account|settings|login|signup|sign-in|sign-up|forgot-password|reset-password|verify|checkout|cart|orders?|mail)(\/|$)/;
const LOW_PRIORITY_GEO_LANDING_PATTERN = /^(call-center-for-|outsourcing-)[a-z0-9-]+$/;

export function extractSeoRoutePath(pathname: string): string {
  const segments = pathname.replace(/^\//, '').split('/').filter(Boolean);
  if (segments.length === 0) return '';
  return LANGUAGE_SEGMENT_PATTERN.test(segments[0])
    ? segments.slice(1).join('/')
    : segments.join('/');
}

export function isPrivateSeoRoute(routePath: string): boolean {
  if (!routePath) return false;
  return PRIVATE_UTILITY_ROUTE_PATTERN.test(routePath);
}

export function isThinSeoPage(routePath: string): boolean {
  if (!routePath) return false;

   if (LOW_PRIORITY_GEO_LANDING_PATTERN.test(routePath)) {
    return true;
  }

  const isCoreRoute = CORE_ROUTE_PATTERN.test(routePath);
  const isRegionalLandingPage = REGIONAL_LANDING_ROUTE_PATTERN.test(routePath);
  const isStrategicBpoCluster = STRATEGIC_BPO_CLUSTER_PATTERN.test(routePath);
  const isCommercialProgrammaticServicePage = PROGRAMMATIC_COMMERCIAL_ROUTE_PATTERN.test(routePath);
  const isSoftwareRegionPage = SOFTWARE_REGION_ROUTE_PATTERN.test(routePath);

  return !isCoreRoute
    && !isRegionalLandingPage
    && !isStrategicBpoCluster
    && !isCommercialProgrammaticServicePage
    && !isSoftwareRegionPage
    && THIN_PROGRAMMATIC_PATTERN.test(routePath);
}
